import { render, staticRenderFns } from "./BMXXlist.vue?vue&type=template&id=8937e43c&"
import script from "./BMXXlist.vue?vue&type=script&lang=js&"
export * from "./BMXXlist.vue?vue&type=script&lang=js&"
import style0 from "./BMXXlist.vue?vue&type=style&index=0&id=8937e43c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports